import { render, staticRenderFns } from "./ProgramOverviewImageDialogCpt.vue?vue&type=template&id=ff41c0f2&scoped=true&"
import script from "./ProgramOverviewImageDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./ProgramOverviewImageDialogCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff41c0f2",
  null
  
)

export default component.exports